var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.remote && _vm.inProgress)?_c('b-btn',_vm._g(_vm._b({attrs:{"disabled":true}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n               "),_c('i',{staticClass:"fas fa-clock"}),_vm._v("       \n    ")]):_c('b-btn',_vm._g(_vm._b({},'b-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }